module.exports = __webpack_public_path__ + "img/centi.02b69211.png";